module.exports = __webpack_public_path__ + "assets/img/icon_information.2a9828de.svg";